<template>
  <div class="comment">
      <div class="comment-head">
        <figure class="comment-user">
          <img src="@/assets/images/user.svg" :alt="item.nickname" />
        </figure>
        <div class="comment-main">
          <div class="comment-main-top">
            <p class="comment-name">{{item.nickname}}さんのレビュー / {{item.age}}</p>
            <p class="comment-reco">
              <span class="comment-reco-text">おすすめ度</span>
              <part-star v-if="item.evaluation !== 6" :ten="toInteger(item.evaluation, false)" :one="toInteger(item.evaluation, true)" />
              <span v-else class="comment-reco-nothing">評価しない</span>
            </p>
            <p class="comment-date" v-text="date" />
          </div>
          <ul class="comment-type">
            <li class="comment-type-li"><span v-if="item.skincare1" v-text="skin1Text" /></li>
            <li class="comment-type-li"><span v-if="item.skincare2" v-text="skin2Text" /></li>
            <li class="comment-type-li"><span v-if="item.worrisome" v-text="item.worrisome" /></li>
            <li class="comment-type-li"><span v-if="item.makeup" v-text="item.makeup" /></li>
          </ul>
        </div>
      </div>
      <div class="comment-text" :class="[{'comment-text--long': commentLong}, {'comment-text--open': view}]">
        <span v-if="commentLong && !view" v-html="shortText" />
        <p v-else v-html="item.public_review" />
        <button v-if="commentLong && !view" class="comment-text-more" @click="more">続きを見る</button>
      </div>
  </div>
</template>

<script>
import toInteger from '@/modules/toInteger.js';
import partStar from './partStar.vue';

export default {
  components: { partStar },
  name: 'SortResultComment2',
  props: {
    item: {
      type: Object
    },
    isSP: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      view: false
    };
  },
  computed: {
    skin1Text() {
      return '春夏/' + this.item.skincare1;
    },
    skin2Text() {
      return '秋冬/' + this.item.skincare2;
    },
    date() {
      return this.item.regist_date.split(' ')[0];
    },
    commentLong() {
      return this.isSP ? this.item.public_review.length > 100 : this.item.public_review.length > 156;
    },
    shortText() {
      return this.isSP ? this.item.public_review.slice(0, 100) : this.item.public_review.slice(0, 156)
    },
  },
  methods: {
    toInteger,
    /**
     * もっと見るボタンを押した時
     */
    more() {
      this.view = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.comment {
  text-align: left;
  width: 271/295 * 100%;
  margin: 0 auto;
  padding: 10/295 * 100% 0 15/295 * 100%;
  @include media() {
    width: 760/800 * 100%;
    padding: 13px 0 20px;
  }
  &-head {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
  &-main {
    display: contents;
    @include media() {
      display: flex;
      flex-wrap: wrap;
      width: calc(100% - 61px);
      align-items: center;
    }
    &-top {
      width: 230/271 * 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      @include media() {
        display: contents;
      }
    }
  }
  &-user {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32/271 * 100%;
    height: 32/375 * 100vw;
    border: 1px solid #DF0168;
    border-radius: 50%;
    @include media() {
      width: 46px;
      height: 46px;
    }
    img {
      width: 13/375 * 100vw;
      @include media() {
        width: 19px;
      }
    }
  }
  &-name {
    font-size: 12/375 * 100vw;
    line-height: (26/12);
    font-weight: bold;
    letter-spacing: .05em;
    @include media() {
      width: 100%;
      font-size: 16px;
      left: (30/16);
      margin-right: auto;
    }
  }
  &-reco {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    @include media() {
      margin-right: 10px;
    }
    &-text {
      margin-right: 3/375 * 100vw;
      font-size: 11/375 * 100vw;
      letter-spacing: 0;
      @include media() {
        margin-right: 4px;
        font-size: 12px;
      }
    }
    &-nothing {
      color: #999;
      font-size: 11/375 * 100vw;
      letter-spacing: 0;
      @include media() {
        font-size: 12px;
      }
    }
  }
  &-date {
    font-size: 11/375 * 100vw;
    letter-spacing: .05em;
    @include media() {
      font-size: 12px;
      position: absolute;
      top: 17px;
      right: 20px;
    }
  }
  &-type {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 10/271 * 100% 0 0;
    padding: 0;
    @include media() {
      margin: 0;
      width: auto;
    }
    &-li {
      margin-right: 5/375 * 100vw;
      margin-bottom: 5/375 * 100vw;
      @include media() {
        margin-right: 6px;
        margin-bottom: 0;
      }
      span {
        display: block;
        border: 1px solid #DF0168;
        border-radius: 11/375 * 100vw;
        padding: 2/375 * 100vw 6/375 * 100vw 3/375 * 100vw;
        color: #DF0168;
        font-size: 10/375 * 100vw;
        white-space: nowrap;
        @include media() {
          padding: 1px 6px 2px;
          border-radius: 11px;
          font-size: 10px;
        }
      }
    }
  }
  &-text {
    margin: 15/271 * 100% 0 0;
    font-size: 12/375 * 100vw;
    line-height: (20/12);
    @include media() {
      margin: 20px 0 0;
      font-size: 14px;
      line-height: (24/14);
    }
    &-more {
      color: #DF0168;
      font-size: 12/375 * 100vw;
      line-height: (20/12);
      @include media() {
        font-size: 14px;
        cursor: pointer;
        transition: .15s ease;
        &:hover {
          opacity: .8;
        }
      }
      &::before{
        content: '...';
        display: inline-block;
        padding: 0 0.25em;
        color: #333;
      }
    }
  }
}
</style>
